<script lang="ts">
	import GaugeChart from '$lib/components/charts/GaugeChart.svelte';

	export let value: number;
	export let color: string = null;
	export let title: string = null;
</script>

<GaugeChart {value} {color} {title} />
